import { IDmLoaiThuBoSungKienThucRequest } from "../../model/request/category/dmLoaiThuBoSungKienThucRequest";
import { IDmLoaiThuBoSungKienThuc } from "../../model/respone/category/IDmLoaiThuBoSungKienThuc";
import { apiClient } from "../apiClient";
export const LOAI_THU_BO_SUNG_KIEN_THUC_ENDPOINT = "loai-thu-bo-sung-kien-thuc";
export const loaiThuBoSungKienThucApi = {
  SelectViewModelAll: () =>
    apiClient.get(`${LOAI_THU_BO_SUNG_KIEN_THUC_ENDPOINT}`),
  Insert: (payload: IDmLoaiThuBoSungKienThuc) =>
    apiClient.post(`${LOAI_THU_BO_SUNG_KIEN_THUC_ENDPOINT}`, payload),
  Update: (payload: IDmLoaiThuBoSungKienThuc) =>
    apiClient.put(`${LOAI_THU_BO_SUNG_KIEN_THUC_ENDPOINT}`, payload),
  Delete: (id: number) =>
    apiClient.delete(`${LOAI_THU_BO_SUNG_KIEN_THUC_ENDPOINT}/${id}`),
  DeleteMany: (ids: number[]) =>
    apiClient.post(`${LOAI_THU_BO_SUNG_KIEN_THUC_ENDPOINT}/delete-many`, ids),
  SelectHeNganhs: (payload: IDmLoaiThuBoSungKienThucRequest) =>
    apiClient.post(
      `${LOAI_THU_BO_SUNG_KIEN_THUC_ENDPOINT}/select-he-nganhs`,
      payload,
    ),
  InsertMultiple: (payload: IDmLoaiThuBoSungKienThuc[]) =>
    apiClient.post(
      `${LOAI_THU_BO_SUNG_KIEN_THUC_ENDPOINT}/insert-multiple`,
      payload,
    ),
  SelectByDot: (payload: IDmLoaiThuBoSungKienThucRequest) =>
    apiClient.post(
      `${LOAI_THU_BO_SUNG_KIEN_THUC_ENDPOINT}/select-by-dot`,
      payload,
    ),
};
